const status = {
    1: "Pending",
    2: "Accepted",
    3: "Rejected",
};

const statusByName = {
    Pending: 1,
    Accepted: 2,
    Rejected: 3,
};

module.exports = { status, statusByName };
